
// App.js

import React, { useContext, useEffect } from 'react';
import PublicRoutes from './routes/Public_routes.js';
import PrivateRoutes from './routes/Private_routes.js';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthContext } from './contexts/AuthContext';

import './App.css';


function App() {
  const { auth, setAuth } = useContext(AuthContext); // Adicione setAuth para atualizar o estado de autenticação

  // Efeito para verificar o token no localStorage e atualizar o estado de autenticação
  useEffect(() => {
    const token = localStorage.getItem('token');
    setAuth(!!token); // Atualiza o estado de autenticação baseado na presença do token

    // Opcional: adicionar um listener para remover o token em caso de logout
    const handleLogout = () => {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('name');
      localStorage.removeItem('role');
      setAuth(false); // Atualiza o estado de autenticação para falso
    };

    window.addEventListener('logout', handleLogout); // Isso é apenas uma demonstração; você deve implementar um logout real

    return () => {
      window.removeEventListener('logout', handleLogout);
    };
  }, [setAuth]); // Adicione setAuth à lista de dependências

  return (
    <ThemeProvider>
      {auth ? <PrivateRoutes /> : <PublicRoutes />}
    </ThemeProvider>
  );
}

export default App;